
import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';
import {Headers, Http, RequestMethod, RequestOptions, ResponseContentType} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {SocialUser} from 'angularx-social-login';
import {Observable} from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';


export interface Credentials {
  username: string;
  token: string;
  cpf: string;
  profileImage: string;
  status: number;
  accrediteds: any[];
}

export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}

const credentialsKey = 'credentials';
const isAccreditedKey = 'isAccredited';

@Injectable()
export class AuthenticationService {

  // public URL_AUTHENTICATE = '/auth/authenticate';
  public URL_AUTHENTICATE_SITE = '/auth/authenticate/site';
  public URL_AUTHENTICATE_ACCREDITED = '[ACCREDITED]/auth/authenticate';
  public URL_INVALIDADE = '/auth/invalidate';
  public URL_CONFIRM_CODE = '/user/confirmcode';
  public URL_CONFIRM_LOGIN = '/auth/confirm-login-site';

  private _credentials: Credentials | null;
  private _isAccredited: boolean | false;

  constructor(private httpService: Http) {
    const savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
    const isAccredited = sessionStorage.getItem(isAccreditedKey) || localStorage.getItem(isAccreditedKey);

    this._isAccredited = isAccredited ? isAccredited === 'true' : false;

    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  /**
   * Authenticates the user.
   * @param {LoginContext} context The login parameters.
   * @return {Observable<Credentials>} The user credentials.
   */
  login(context: LoginContext): Observable<Credentials> {

    const encodString = btoa(this.cpf(context.username) + ':' + context.password);

    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('provider', 'Wynk');
    options.headers.append('Content-Type', 'application/json');
    options.headers.append('Authorization', 'Basic ' + encodString);
    // options.headers.append('siteid', 'wynkbrowser2021');


    return this.httpService.get(this.URL_AUTHENTICATE_SITE, options)
      .pipe(
        map( (ret) => {
          const data =  ret.json();
          // this.setCredentials( data, context.remember);
          // this.getUseSession(context.remember);
          return data;
        }),
        catchError(this.handleError)
      );
  }
  // login(context: LoginContext): Observable<Credentials> {
  //
  //   const encodString = btoa(this.cpf(context.username) + ':' + context.password);
  //
  //   const options = new RequestOptions();
  //   options.headers = new Headers();
  //   options.headers.append('provider', 'Wynk');
  //   options.headers.append('Content-Type', 'application/json');
  //   options.headers.append('Authorization', 'Basic ' + encodString);
  //
  //   return this.httpService.get(this.URL_AUTHENTICATE, options)
  //     .pipe(
  //       map( (ret) => {
  //         const data =  ret.json();
  //         this.setCredentials( data, context.remember);
  //         this.getUseSession(context.remember);
  //         return data;
  //       }),
  //       catchError(this.handleError)
  //     );
  // }

  /**
   * Authenticates the user (ACCREDITED).
   * @param {LoginContext} context The login parameters.
   * @return {Observable<Credentials>} The user credentials.
   */
  loginAccredited(context: LoginContext): Observable<Credentials> {

    const encodString = btoa(context.username + ':' + context.password);

    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    options.headers.append('Authorization', 'Basic ' + encodString);

    return this.httpService.get(this.URL_AUTHENTICATE_ACCREDITED, options)
      .pipe(
        map( (ret) => {
          const data =  ret.json();
          const credentials = <Credentials>{
            username: data.name,
            profileImage: data.profileImage,
            status: 1,
            token: data.token,
            accrediteds: data.accrediteds
          };
          this.setCredentials( credentials, context.remember, true);
          return data;
        }),
        catchError(this.handleError)
      );
  }

  confirmLogin(hash: string ): Observable<Credentials> {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');

    return this.httpService.post(this.URL_CONFIRM_LOGIN, {hash: hash}, options)
      .pipe(
        map( (ret) => {
            const credentials =  ret.json();
            if (credentials.status === 1) {
              this.setCredentials( credentials, true);
              this.getUseSession(true);
              return credentials;
            }
            return credentials;
          }
        ),
        catchError(this.handleError)
      );
  }

  confirmRegister(hash: string ): Observable<Credentials> {

    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');

    return this.httpService.post(this.URL_CONFIRM_CODE, {hash: hash}, options)
      .pipe(
        map( (ret) => {
            const credentials =  ret.json();
            if (credentials.status === 1) {
              this.setCredentials( credentials, true);
              this.getUseSession(true);
              return credentials;
            }
            return credentials;
          }
        ),
        catchError(this.handleError)
      );
  }

  loginSocial(socialUser: SocialUser, isFacebook: boolean): Observable<any> {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('provider', isFacebook ? 'Facebook' : 'Google');
    options.headers.append('Content-Type', 'application/json');
    options.headers.append('token', isFacebook ? socialUser.authToken : socialUser.idToken );

    return this.httpService.get(this.URL_AUTHENTICATE_SITE, options)
      .pipe(
        map( (ret) => {
            const data =  ret.json();
            if (data.status === 1) {
              this.setCredentials( data, true);
              this.getUseSession(true);
              return data;
            }
            return data;
          }
        ),
        catchError(this.handleError)
      );
  }

  cpf(value: string): string {
    value = value.replace( /\D/g , '');
    value = value.replace( /(\d{3})(\d)/ , '$1.$2');
    value = value.replace( /(\d{3})(\d)/ , '$1.$2');
    value = value.replace( /(\d{3})(\d{1,2})$/ , '$1-$2');
    return value;

  }

  private getUseSession(remember: boolean) {
    this.httpService.get('/user')
      .subscribe(response => {
        const user = response.json();
        const cred = this.credentials;
        cred.username = user.name;
        cred.cpf = user.cpf;
        cred.profileImage = user.profileImage;
        this.setCredentials(cred, remember);
      }, error => {
          console.log(error);
      });
  }


  private handleError(error: any) {
    const errMsg = (error.message) ?
      error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return Observable.throw(error);
  }
  /**
   * Logs out the user and clear credentials.
   * @return {Observable<boolean>} True if the user was logged out successfully.
   */
  logout(): Observable<any> {
    this._credentials = null;
    sessionStorage.clear();
    localStorage.clear();

    return this.httpService.post(this.URL_INVALIDADE, {}, new RequestOptions())
      .pipe(
        map( (ret) => {
            return of(true);
          }
        ),
        catchError(this.handleError)
      );
  }

  /**
   * Checks is the user is authenticated.
   * @return {boolean} True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  /**
   * Gets the user credentials.
   * @return {Credentials} The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    return this._credentials;
  }

  isAccredited(): boolean {
    return this._isAccredited;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param {Credentials=} credentials The user credentials.
   * @param {boolean=} remember True to remember credentials across sessions.
   * @param {boolean=} isAccredited True to login as credited.
   */
  setCredentials(credentials?: Credentials, remember?: boolean, isAccredited: boolean = false) {
    this._credentials = credentials || null;

    if (credentials) {
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
      if (isAccredited) {
        storage.setItem(isAccreditedKey, 'true');
      }
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/authentication/authentication.service.ts